var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsCheckedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333344,
    width: 44,
    height: 44,
    rx: 21,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5733 32.2705H25.4433C21.0033 32.2705 18.8633 30.5205 18.4933 26.6005C18.4533 26.1905 18.7533 25.8205 19.1733 25.7805C19.5833 25.7405 19.9533 26.0505 19.9933 26.4605C20.2833 29.6005 21.7633 30.7705 25.4533 30.7705H25.5833C29.6533 30.7705 31.0933 29.3305 31.0933 25.2605V18.7405C31.0933 14.6705 29.6533 13.2305 25.5833 13.2305H25.4533C21.7433 13.2305 20.2633 14.4205 19.9933 17.6205C19.9433 18.0305 19.6033 18.3405 19.1733 18.3005C18.7533 18.2705 18.4533 17.9005 18.4833 17.4905C18.8233 13.5105 20.9733 11.7305 25.4433 11.7305H25.5733C30.4833 11.7305 32.5833 13.8305 32.5833 18.7405V25.2605C32.5833 30.1705 30.4833 32.2705 25.5733 32.2705Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2133 22.7505H12.3333C11.9233 22.7505 11.5833 22.4105 11.5833 22.0005C11.5833 21.5905 11.9233 21.2505 12.3333 21.2505H25.2133C25.6233 21.2505 25.9633 21.5905 25.9633 22.0005C25.9633 22.4105 25.6333 22.7505 25.2133 22.7505Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9833 26.1005C22.7933 26.1005 22.6033 26.0305 22.4533 25.8805C22.1633 25.5905 22.1633 25.1105 22.4533 24.8205L25.2733 22.0005L22.4533 19.1805C22.1633 18.8905 22.1633 18.4105 22.4533 18.1205C22.7433 17.8305 23.2233 17.8305 23.5133 18.1205L26.8633 21.4705C27.1533 21.7605 27.1533 22.2405 26.8633 22.5305L23.5133 25.8805C23.3633 26.0305 23.1733 26.1005 22.9833 26.1005Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsCheckedIn);
export default __webpack_public_path__ + "static/media/statistics-checked-in.96c610f337d6ec9811eb56b412f8db26.svg";
export { ForwardRef as ReactComponent };